// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a3f712b1","239":"30b0f3ab","455":"4cea6fad"}[chunkId] + ".chunk.js";
};